import * as angular from 'angular';
import * as d3 from 'd3';
import * as _ from 'lodash';

import { ITemplateService } from '../../../services';
import { ComponentDefinition } from '../../../models';
import { templateForceRefresh } from '../../../common';

class GroupChangesByTemplateController implements angular.IComponentController {
    isLoading: boolean;
    tuples: any[];
    displayed: any[];
    selectedCount: number;

    static $inject = ['$rootScope', 'templateService'];

    constructor(private _$rootScope: angular.IRootScopeService,
        private _templateService: ITemplateService) {
    }

    $onInit() {
        if (!this.tuples) {
            this.tuples = [];
        }

        this.refresh();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['tuples'] && changesObj['tuples'].currentValue) {
            this.refresh();
        }
    }

    private refresh() {
        const templates = this.tuples.filter(d => d.template).map(d => d.template);

        const byTemplateGuid = d3.nest<any>()
            .key(d => d.group.templateGuid)
            .entries(this.tuples);

        const displayed = [];
        byTemplateGuid.forEach(d => {
            const foundTemplate = templates.find((t: any) => t.guid === d.key);
            if (foundTemplate) {
                displayed.push(
                    {
                        template: foundTemplate,
                        groups: d.values
                    });
            }
        });
        this.displayed = displayed.sort((a, b) => d3.ascending(a.template.name, b.template.name));
    }

    applyAllFromTemplate(templateGuid: string): void {
        this.isLoading = true;
        const p = this._templateService.applyAllFromTemplate(templateGuid);
        this.refreshAfterLoading(p);
    }

    ignoreAllFromTemplate(templateGuid: string): void {
        this.isLoading = true;
        const p = this._templateService.ignoreAllFromTemplate(templateGuid);
        this.refreshAfterLoading(p);
    }

    private refreshAfterLoading(promise: angular.IPromise<any>): void {
        promise.then(() => {
            this._$rootScope.$broadcast(templateForceRefresh);
        }).finally(() => {
            this.isLoading = false;
        });
    }
}

export const wtGroupChangesByTemplate: ComponentDefinition = {
    componentId: 'wtGroupChangesByTemplate',
    controller: GroupChangesByTemplateController,
    controllerAs: 'vm',
    template: require('./groupChangesByTemplate.component.html'),
    bindings: {
        changes: '=',
        selectedGroup: '=',
        selectedTuple: '=?',
        tuples: '<',
        showIgnored: '<',
        selectedCount: '<'
    }
};